import { render } from "./FullscreenCamera.vue?vue&type=template&id=16ced1be&scoped=true"
import script from "./FullscreenCamera.vue?vue&type=script&lang=js"
export * from "./FullscreenCamera.vue?vue&type=script&lang=js"

import "./FullscreenCamera.vue?vue&type=style&index=0&id=16ced1be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16ced1be"]])

export default __exports__